'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var shortenText = function shortenText(text, length) {
  text = typeof text === 'string' ? text : '';
  while (length < text.length && /[a-zA-Z]/.test(text[length])) {
    length += 1;
  }

  return '' + text.slice(0, length) + (text.length > length ? '…' : '');
};

exports.default = shortenText;